<template>

	<div class="container-flex" ref="sContent" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">

		<div :class="isFullScreen ? 'exit-fullscreen':'fullscreen'" @click="toggleScreen">
		</div>

		<div class="box-left">
			<div class="left-top">
				<div class="current-num">
					<div>当前单车数量总数</div>
					<p>{{ total }}</p>
				</div>
			</div>
			<div class="left-center">
				<div class="title-box">
					<h6>单车数量占比 </h6>
					<p class="unit" style="float: right">单位（辆）</p>
				</div>
				<div class="chart-box pie-chart">
					<div id="pie"></div>
					<div>
						<div class="pie-data" v-html="str">

						</div>
					</div>
				</div>
			</div>
			<div class="left-bottom select">
				<div class="title-box">
					<h6>季度评分</h6>

				</div>
				<div class="chart-box">

					<div class="settings-box">
						<ul>
							<li v-for="(item,index) in marketing" :index="index">
								<img v-if="item.operatorName==='美团'" src="../../assets/images/mt1.png">
								<img v-else-if="item.operatorName==='哈啰'" src="../../assets/images/hl1.png">
								<img v-else-if="item.operatorName==='青桔'" src="../../assets/images/dd1.png">
								<span style="color: #ffffff;font-size: 0.18rem;line-height: 30px">({{item.year}}年第{{item.quarter}}季度)</span>
								<div class="text">
									<div class="score">
										<h2>季度总评分</h2>
										<span>{{item.totalPoints}}  </span> </div>
									<div class="ranking">
										<h2>季度评分排名</h2>
										<span>

                       <img v-if="item.grade=='A'" src="../../assets/images/a1.png">
                       <img v-else-if="item.grade=='B'"  src="../../assets/images/b1.png" >
                       <img v-else-if="item.grade=='C'"  src="../../assets/images/c1.png" >
                       <img v-else-if="item.grade=='D'"  src="../../assets/images/d1.png" >
						              </span> </div>
								</div>
							</li>

						</ul>

					</div>

				</div>
			</div>
		</div>
		<div class="box-center">
			<!-- <div class="center-top">
				<h1>互联网租赁自行车监管考核大数据平台</h1>
			</div> -->
			<div class="center-center">
				<!-- <div class="weather-box" style="z-index: 99">
					<div class="data">
						<p class="time" id="time" v-html="time"></p>
						<p id="date" v-html="newdata"></p>
					</div>
					<div class="1" id="">
						太原
					</div>
				</div>
				<img src="../../assets/images/line_bg.png" alt=""> -->
				<div class="select-box">
					<ul id="barType">
						<li v-for="item in items" @click="getsettab(item.id)" :class="{active : item.id===curId}" data-value="item.id"> {{ item.label }}</li>

					</ul>
					<div data-type="2">
						<div class="select">
							<input type="text" @keyup="" class="select-div" v-model="selectVehicleGpsname" placeholder="请输入车牌" />

						</div>
						<!--            <div class="select" >-->
						<!--              <input type="text" class="select-div" placeholder="请输入编号：" />-->

						<!--            </div>-->

					</div>
					<button class="select" @click="mesmes()" style="width: 0.8rem; margin-top:1.05rem;     border: 1px solid #0E94EA; background: #0e94eb;     position: absolute;   bottom: 0rem; left: 2.4rem;   cursor: pointer;">查询</button>

				</div>
			</div>
			<div class="center-bottom" ref="sContents">
				<div :class="isFullScreen ? 'exit-fullscreens':'fullscreens'" @click="toggleScreens">
						</div>
				<div class="chart-box">
					<div style="width:100%;height:95%;">

						<!--百度地图-->
						<!--<baidu-map class="map" :center="center" :zoom="zoom"  :panel="false" :autoViewport="true" :scroll-wheel-zoom="true" :map-click="false" @ready="handler">


              
          		<bm-info-window :position="pointDetailPosition" title="" :show="pointDetailShow" @close="pointDetailShow=false" @open="pointDetailShow=true">
					      <p class="mapDian_box_li">
                    <span class="mapDian_box_li_l">车牌号:</span>
                    <span class="mapDian_box_li_r">{{pointDetail.vehicleLicenseTag}}</span>
                </p>
 
                <p class="mapDian_box_li">
                    <span class="mapDian_box_li_l">车头码:</span>
                    <span class="mapDian_box_li_r">{{pointDetail.vehicleHeadNum}}</span>
                </p>
 
                <p class="mapDian_box_li">
                    <span class="mapDian_box_li_l">车锁码:</span>
                    <span class="mapDian_box_li_r">{{pointDetail.vehicleLockNum}}</span>
                </p>
					    </bm-info-window>
					    <!--<bm-point-collection :points="points" shape="BMAP_POINT_SHAPE_CIRCLE" size="BMAP_POINT_SIZE_BIG" :color="color"  @click="clickHandler">
             </bm-point-collection>-->

						<!--<bml-marker-clusterer :averageCenter="true" >
			    	<bm-marker v-for="marker of points"  :position="{lng: marker.lng, lat: marker.lat }"  @click="clickHandler_juhe(marker)"></bm-marker>
			  	</bml-marker-clusterer>
			    <bm-polygon :path="polygonPath" stroke-color="blue" :stroke-opacity="0.5" :stroke-weight="2" />
	           	
            </baidu-map>-->

						<!--高德地图-->
						<div id="container_gaode"></div>

					</div>
				</div>
				<div class="city-data">

				</div>
			</div>

		</div>
<!-- 		<div class="box-right">
			<div class="right-top">
				<div class="title-box">
					<h6 id="barTitle"> 用户满意度统计</h6>
					<p class="unit">单位（份）</p>
				</div>

				<div class="chart-box">
					<div id="chart3" style="width:94%;height:225px;padding: 0 5%"></div>
				</div>

			</div>
			<div class="right-center">
				<div class="title-box">
					<p id="switchBtn">
						<span class="active">评分细则({{operatorname}}:{{years}}年第{{quarters}}季度)</span>
					</p>
				</div>
				<div class="data-box">

					<ul class="ranking-box1">
						<li>
							<p>指标项与分值</p>
							<p>评分 （单位/分）</p>
						</li>

						<li>
							<p>总分</p>
							<p>{{total_points}}</p>
						</li>
						<vue-seamless-scroll :data="itemlist" :class-option="optionHover" class="seamless-warp">
							<li v-for="(item,index) in itemlist" :key='index'>
								<p>{{item.scoreItem}}</p>
								<p>{{item.itemScore}}</p>
							</li>
						</vue-seamless-scroll>
					</ul>

				</div>
			</div>

		</div> -->
	</div>

</template>
<script>
	import { BmlMarkerClusterer } from '../../../src/components/vue-baidu-map/components'
	import screenfull from "screenfull";
	import mtImg from "@/assets/images/mtm.png";
	import hlImg from "@/assets/images/hlm.png";
	import qjImg from "@/assets/images/qjm.png";
	var map;
	export default({
		name: "Index",
		components: {
			BmlMarkerClusterer
		},
		data() {
			return {
				markers: [],
				stylesArr: [{
					url: 'http://api.map.baidu.com/library/MarkerClusterer/1.2/examples/images/heart30.png',
					size: {
						width: 30,
						height: 26
					},
					opt_anchor: [16, 0],
					textColor: '#ff00ff',
					opt_textSize: 2
				}],
				polygonPath: [[]],
				polygonPath_two: [[]],
				markIcon: {
					url: mtImg,
					size: {
						width: 20,
						height: 20
					}
				},
				points: [],
				pointDetail: {},
				pointDetailPosition: {},
				pointDetailShow: false,
				center: {
					lng: 0,
					lat: 0
				},
				zoom: 3,
				quarters: '',
				years: '',
				operatorname: "",
				isFullScreen: false,
				total: 0,
				mt: 0,
				dd: 0,
				hl: 0,
				str: [],
				marketing: [],
				time: '',
				newdata: '',
				itemlist: [],
				total_points: 0,
				gradeId: 0,
				curId: 1,
				selectVehicleGpsname: '',
				items: [{
						id: 1,
						type: 'success',
						label: '美团'
					},
					{
						id: 2,
						type: 'info',
						label: '哈啰'
					},
					{
						id: 3,
						type: 'danger',
						label: '青桔'
					},
				],
				color: '#FFD103',
				loading: true,
				source:[]
			}

		},

		beforeRouteEnter(to, from, next) {

			next((vm) => {

			});
		},
		created() {
			// 插入 10 个随机点
			const markers = []
			for(let i = 0; i < 100; i++) {
				const position = {
					lng: Math.random() * 40 + 85,
					lat: Math.random() * 30 + 21,
					id: 123
				}
				this.markers.push(position)
			}

			screenfull.on('change', () => {
					// console.log('当前是否是全屏', screenfull.isFullscreen)
					this.isFullScreen = screenfull.isFullscreen
				}),
				//和风天气插件调用
				window.WIDGET = {
					"CONFIG": {
						"modules": "012",
						"background": "5",
						"tmpColor": "FFFFFF",
						"tmpSize": "14",
						"cityColor": "FFFFFF",
						"citySize": "14",
						"aqiColor": "FFFFFF",
						"aqiSize": "14",
						"weatherIconSize": "20",
						"alertIconSize": "18",
						"padding": "10px 0px 10px 0px",
						"shadow": "0",
						"language": "auto",
						"fixed": "false",
						"vertical": "top",
						"horizontal": "left",
						"key": "d511cc9795ae44f7a68e3d3d86cc962a"
					}
				};
			var script = document.createElement('script');
			script.type = 'text/javascript';
			script.src = "https://widget.qweather.net/simple/static/js/he-simple-common.js?v=2.0";
			document.getElementsByTagName('head')[0].appendChild(script);

		},
		mounted() {
			this.settale();
			this.selectGrade();

			this.countStatisfaction();
//			this.showec();
			this.getsettab(1);

			window.setInterval(() => {
				this.getdatass()
			}, 1000)

		},

		methods: {
			handler({
				BMap,
				map
			}) {
				this.center.lng = 112.561119
				this.center.lat = 37.825375
				this.zoom = 18;
				let that = this;
				that.map = map;
				map.setMapStyleV2({
					styleId: '33891ef4fe4cd5da0f85566014bc9acb'
				});
			},
			getdatass() {
				let date = new Date();
				let year = date.getFullYear(); //当前年份
				let month = date.getMonth(); //当前月份
				let data = date.getDate(); //天
				let hours = date.toLocaleTimeString(); //小时
				let day = date.getDay(); //获取当前星期几
				this.time = hours;
				let weeks = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
				this.newdata = '<span>' + year + '/' + (month + 1) + '/' + data + '</span><span> </span><span>' + weeks[day] + '</span>'
			},

			mesmes(val) {
				let that = this;
				if(!val) {
					if(this.selectVehicleGpsname == '') {
						this.$message.error('请输入车牌！！！');
						return false;
					}
				} else {
					if(this.selectVehicleGpsname) {
						return false;
					} else {
						if(this.curId == 1) {
							operatorNum = "MT";
						} else if(this.curId == 2) {
							operatorNum = "HL";
						} else if(this.curId == 3) {
							operatorNum = "DD";
						}
						this.selectVehicleGpsList(operatorNum)
						return false;
					}
				}
				let operatorNum = '';
				if(this.curId == 1) {
					operatorNum = "MT";
					this.markIcon = {
						url: mtImg,
						size: {
							width: 20,
							height: 20
						}
					}
				} else if(this.curId == 2) {
					operatorNum = "HL";
					this.markIcon = {
						url: hlImg,
						size: {
							width: 20,
							height: 20
						}
					}
				} else if(this.curId == 3) {
					operatorNum = "DD";
					this.markIcon = {
						url: qjImg,
						size: {
							width: 20,
							height: 20
						}
					}
				}

				let selectVehicleGpsdata = {
					vehicleLicenseTag: this.selectVehicleGpsname,
					operatorNum: operatorNum,
				}
				this.$axios
					.post('/api/vehicleGps/selectVehicleGps', selectVehicleGpsdata)
					.then(function(res) {

						if(res.data.code == 200) {
							console.log(res.data.data)
//							that.center.lng = res.data.data.longitude;
//							that.center.lat = res.data.data.latitude;
//							that.zoom = 22
							// 设置缩放级别和中心点
        					map.setZoomAndCenter(22, [res.data.data.longitude, res.data.data.latitude]);
//							var pos = {
//								lng: res.data.data.longitude,
//								lat: res.data.data.latitude
//							}
//							const position = {
//								lng: res.data.data.longitude,
//								lat: res.data.data.latitude,
//								vehicleLicenseTag: res.data.data.vehicleLicenseTag,
//								vehicleHeadNum: res.data.data.vehicleHeadNum,
//								vehicleLockNum: res.data.data.vehicleLockNum,
//								pos: pos,
//								show: true
//							}
//							var arr = [];
//							arr.push(position)
//							that.points = arr;
						} else {
							that.$message.error(res.data.msg)
						}

					})
					.catch(function(error) { // 请求失败处理
						console.log("服务器错误" + error);
					});
			},
			toggleScreen() {
				screenfull.toggle(this.$refs.sContent)
				this.isFullScreen = !this.isFullScreen
			},
			toggleScreens() {
				screenfull.toggle(this.$refs.sContents)
				this.isFullScreen = !this.isFullScreen
			},

			settale() {
				let that = this;
				let myDate = new Date();
				let years = myDate.getFullYear(); //获取当前年
				let mon = myDate.getMonth() + 1; //获取当前月
				let aquarters = 1
				if(mon >= 1 && mon < 4) {
					aquarters = 1;
				} else if(mon >= 4 && mon < 7) {
					aquarters = 2;
				} else if(mon >= 7 && mon < 10) {
					aquarters = 3;
				} else if(mon >= 10 && mon < 13) {
					aquarters = 4;
				}
				// this.ayear =that.ayears||''+years;
				// this.aquarte = that.aquarter || aquarters;
				let countVehicleNumdata = {
					year: years,
					quarter: aquarters,
				}
				this.$axios
					.post('/api/vehicle/countVehicleNum', countVehicleNumdata)
					.then(function(res) {
						if(res.data.code == 200) {
							//console.log(res.data.data)
							let mtvalue = 0;
							let ddvalue = 0;
							let hlvalue = 0;
							for(let i = 0; i < res.data.data.length; i++) {
								that.total = that.total + res.data.data[i].value;
							}
							for(let t = 0; t < res.data.data.length; t++) {
								if(res.data.data[t].name == '美团') {
									that.mt = (res.data.data[t].value / that.total) * 100;
									mtvalue = res.data.data[t].value;
								}
								if(res.data.data[t].name == '青桔') {
									that.dd = (res.data.data[t].value / that.total) * 100;
									ddvalue = res.data.data[t].value;
								}
								if(res.data.data[t].name == '哈啰') {
									that.hl = (res.data.data[t].value / that.total) * 100;
									hlvalue = res.data.data[t].value;
								}
							}

							// that.mt = (res.data.data[0].value /  that.total ) * 100
							//
							// that.dd = (res.data.data[1].value /  that.total ) * 100
							//
							// that.hl = (res.data.data[2].value /  that.total ) * 100

							let startColor = ['#FFD103', '#0096FF','#36d6be' ];
							// var borderStartColor = ['#36d6be', '#36d6be', '#0096FF'];
							let myChart = that.$echarts.init(document.getElementById('pie'));

							window.addEventListener('resize', function() {
								myChart.resize();

							});
							var data = [{
								name: '美团',
								value: mtvalue,
								percent: that.mt,
							}, {
								name: '哈啰',
								value: hlvalue,
								percent: that.hl,
							},{
								name: '青桔',
								value: ddvalue,
								percent: that.dd,
							} ];
							console.log(data)
							for(let i = 0; i < data.length; i++) {
								that.str += '<p><span><i class="legend" style="background:' + startColor[i] + '"></i></span>' + data[i].name + '<span class="pie-number" style="color:' + startColor[i] + '">' + data[i].value + '</span>' + Number(data[i].percent).toFixed(2) + '%</p>';
							}

							function deepCopy(obj) {
								if(typeof obj !== 'object') {
									return obj;
								}
								var newobj = {};
								for(var attr in obj) {
									newobj[attr] = obj[attr];
								}
								return newobj;
							}
							var xData = [],
								yData = [];
							data.map((a, b) => {
								xData.push(a.name);
								yData.push(a.value);
							});

							var RealData = [];
							var borderData = [];
							data.map((item, index) => {
								var newobj = deepCopy(item);
								var newobj1 = deepCopy(item);
								RealData.push(newobj);
								borderData.push(newobj1);
							});
							RealData.map((item, index) => {
								item.itemStyle = {
									normal: {
										color: {
											type: 'linear',
											x: 0,
											y: 0,
											x2: 0,
											y2: 1,
											colorStops: [{
												offset: 0,
												color: startColor[index] // 0% 处的颜色
											}, {
												offset: 1,
												color: startColor[index] // 100% 处的颜色
											}],
											globalCoord: false // 缺省为 false
										},
									}
								}
							});
							let option = {
								tooltip: {
									trigger: 'item',
									//            position: ['30%', '50%'],
									confine: true,
									formatter: "{a} <br/>{b}: {c} ({d}%)"
								},
								series: [
									// 主要展示层的
									{
										radius: ['40%', '85%'],
										center: ['50%', '50%'],
										type: 'pie',
										label: {
											normal: {
												show: false
											},
											emphasis: {
												show: false
											}
										},
										labelLine: {
											normal: {
												show: false
											},
											emphasis: {
												show: false
											}
										},
										name: "单车数量统计",
										data: RealData
									},
									// 边框的设置
									// {
									//   radius: ['45%', '50%'],
									//   center: ['50%', '50%'],
									//   type: 'pie',
									//   label: {
									//     normal: {
									//       show: false
									//     },
									//     emphasis: {
									//       show: false
									//     }
									//   },
									//   labelLine: {
									//     normal: {
									//       show: false
									//     },
									//     emphasis: {
									//       show: false
									//     }
									//   },
									//   animation: false,
									//   tooltip: {
									//     show: false
									//   },
									// //  data: borderData
									// }
								]
							};

							myChart.setOption(option);

						} else {
							that.$message.error(res.data.msg);
						}
					}).catch(function(error) { // 请求失败处理
						console.log("服务器错误" + error);
					});
			},
			countStatisfaction(){
				var that = this;
				that.$axios
					.get('/api/satisfaction/countStatisfaction',)
					.then(function(res) {
						if(res.data.code == 500) {
							that.$message.error( res.data.msg);
							return false;
						} else if(res.data.code == 200) {
//							console.log(res.data.data)
							var source = [];
							for(var i =0;i<3;i++){
								var arr_small = [];
								if(res.data.data[i].operatorNum==1){
									arr_small.push('美团')
								}else if(res.data.data[i].operatorNum==2){
									arr_small.push('青桔出行')
								}else if(res.data.data[i].operatorNum==3){
									arr_small.push('哈罗出行')
								}
								arr_small.push(res.data.data[i].satisfactionNum)
								arr_small.push(res.data.data[i].discontentNum)
								source.push(arr_small);
							}
							console.log(source)
							that.source = source;
							console.log(that.source)
							that.showec();
							
						}
					}).catch(function(error) { // 请求失败处理
						console.log("服务器错误" + error);
					});
			},
			showec() {
				let doms = document.getElementById("chart3");
				let myChart = this.$echarts.init(doms);
				window.addEventListener('resize', function() {
					myChart.resize();

				});
				let app = {};
				let option;
				option = {
					grid: {
						top: '15%',
						left: '15% ',
						bottom: '20%'
					},

					legend: {},
					tooltip: {},
					dataset: {
//						source: [
//							['美团', 71.07, 28.93],
//							['青桔出行', 70.90, 29.10],
//							['哈罗出行', 69.12, 30.88],
//						]
						source:this.source
					},
					xAxis: {
						type: 'category'
					},
					yAxis: {
						type: 'value',
						name: "满意度调查（%）",
						axisLine: {
							show: true
						},
						min: 20,
						max: 80
					},
					series: [{
						type: 'bar',
						itemStyle: {
							normal: {
								color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
										offset: 1,
										color: "#aFE5E2" // 0% 处的颜色
									}, {
										offset: 0.8,
										color: "#aFE5E2" // 60% 处的颜色
									},
									{
										offset: 0.3,
										color: "#7CDF7F" // 60% 处的颜色
									}, {
										offset: 0,
										color: "#7CDF7F" // 100% 处的颜色
									}
								], false)
							}
						},
						barWidth: 10, //柱图宽度
					}, {
						type: 'bar',
						itemStyle: {
							normal: {
								color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
										offset: 1,
										color: "#FD715D" // 0% 处的颜色
									}, {
										offset: 0.8,
										color: "#FD715D" // 60% 处的颜色
									},
									{
										offset: 0.3,
										color: "#E66D8D" // 60% 处的颜色
									}, {
										offset: 0,
										color: "#E66D8D" // 100% 处的颜色
									}
								], false)
							}
						},
						barWidth: 10, //柱图宽度
					}]
				};
				if(option && typeof option === 'object') {
					myChart.setOption(option);
				}
			},
			selectGrade() {
				let that = this;
				this.$axios
					.get('/api/grade/selectOperatorGrade')
					.then(function(res) {

						that.marketing = res.data.data;

					}).catch(function(error) { // 请求失败处理
						console.log("服务器错误" + error);
					});
			},

//			clickHandler(e, target) {
//				console.log(e)
//				return false;
//				var that = this;
//				that.pointDetailShow = false;
//				var pos = {
//					lng: e.point.lng,
//					lat: e.point.lat
//				}
//				that.center.lng = e.point.lng;
//				that.center.lat = e.point.lat;
//				that.zoom = 24;
//				that.pointDetailPosition = pos
//				that.$axios
//					.get('api/vehicleGps/selectVehicle/' + e.point.id)
//					.then(function(res) {
//						if(res.data.code == 200) {
//							console.log(res.data.data[0])
//							that.pointDetail = res.data.data[0]
//							setTimeout(function() {
//								that.pointDetailShow = true
//							}, 100)
//						} else {
//							that.$message.error(res.data.msg);
//						}
//
//					}).catch(function(error) { // 请求失败处理
//						console.log("服务器错误" + error);
//					});
//
//			},
//			clickHandler_juhe(e, target) {
//				console.log(e)
//				var that = this;
//				that.pointDetailShow = false;
//				var pos = {
//					lng: e.lng,
//					lat: e.lat
//				}
//				that.center.lng = e.lng;
//				that.center.lat = e.lat;
//				that.zoom = 24;
//				that.pointDetailPosition = pos
//				that.$axios
//					.get('api/vehicleGps/selectVehicle/' + e.id)
//					.then(function(res) {
//						if(res.data.code == 200) {
//							console.log(res.data.data[0])
//							that.pointDetail = res.data.data[0]
//							setTimeout(function() {
//								that.pointDetailShow = true
//							}, 100)
//						} else {
//							that.$message.error(res.data.msg);
//						}
//
//					}).catch(function(error) { // 请求失败处理
//						console.log("服务器错误" + error);
//					});
//
//			},
			selectVehicleGpsList(code) {
				let that = this;
				that.loading = true;
				let VehicleGpsListdeta = {
					operatorNum: code,
					vehicleLicenseTag: ''
				}
				//          if(that.$store.state.meituan&&code == 'MT'){
				//          	that.points = [];
				//          	that.loading = false;
				//							that.zoom = 14;
				//							for (let i = 0; i < that.$store.state.meituan.length; i++) {
				//                	var pos={
				//                		lng: that.$store.state.meituan[i].longitude, 
				//                  	lat: that.$store.state.meituan[i].latitude
				//                	}
				//                  const position = {
				//                  	lng: that.$store.state.meituan[i].longitude, 
				//                  	lat: that.$store.state.meituan[i].latitude,
				//                  	id:that.$store.state.meituan[i].id,
				//                  	show:false
				//                  }
				//                  that.points.push(position)
				//                }
				//								if(that.$store.state.meituan.length>0){
				//                  if(code == 'MT') {
				//
				//                    that.color = '#FFD103'
				//                  }else if( code == 'HB'){
				//
				//                      that.color='#0096FF'
				//
				//                  }else if(code == 'DD'){
				//
				//                      that.color='#36d6be'
				//
				//                  }
				//
				//                }
				//							return false;
				//          }

				this.$axios
					.post('/api/vehicleGps/selectVehicleGpsList', VehicleGpsListdeta)
					.then(function(res) {
						console.log(res.data)
						that.points = [];
						var arr = [];
						if(res.data.code == 200) {
							that.loading = false;
							that.zoom = 10;
//							for(let i = 0; i < res.data.data.length; i++) {
//								var pos = {
//									lng: res.data.data[i].longitude,
//									lat: res.data.data[i].latitude
//								}
//								const position = {
//									lng: res.data.data[i].longitude,
//									lat: res.data.data[i].latitude,
//									id: res.data.data[i].id,
//									show: false
//								}
//
//							}
//							that.points.push(position)
					
							that.points = res.data.data;
							//点聚合数据赋值
							that.init_gaode(code);
								
							if(res.data.data.length > 0) {
								if(code == 'MT') {
									that.$store.state.meituan = res.data.data;
									that.color = '#FFD103'
								} else if(code == 'HL') {
									that.color = '#0096FF'
								} else if(code == 'DD') {
									that.color = '#36d6be'
								}
							}
						} else {
							console.log("服务器错误" + res.data.msg);
						}
					}).catch(function(error) { // 请求失败处理
						console.log("服务器错误" + error);
					});
			},
			getsettab(index) {

				this.selectGradeByOperatorNums(index);
				let that = this;
				that.selectVehicleGpsname = "";
				that.pointDetailShow = false;
				if(index == 1) {
					this.selectVectorOverlay('MT');
					this.selectVehicleGpsList('MT');
					this.color = '#FFD103'
					this.markIcon = {
						url: mtImg,
						size: {
							width: 20,
							height: 20
						}
					}
				} else if(index == 2) {
					this.selectVectorOverlay('HB');
					this.selectVehicleGpsList('HL');
					this.color = '#36d6be'
					this.markIcon = {
						url: hlImg,
						size: {
							width: 20,
							height: 20
						}
					}
				} else if(index == 3) {
					this.selectVectorOverlay('DD');
					this.selectVehicleGpsList('DD');
					this.color = '#36d6be'
					this.markIcon = {
						url: qjImg,
						size: {
							width: 20,
							height: 20
						}
					}
				}
			},
			selectVectorOverlay(label) {
				var that = this;
				that.$axios
					.get('/api/vehicleGps/selectVectorOverlay/' + label)
					.then(function(res) {
						if(res.data.code == 200) {
								that.polygonPath = res.data.data[0].slist;
						} else {
							that.$message.error(res.data.msg);
						}

					}).catch(function(error) { // 请求失败处理
						console.log("服务器错误" + error);
					});
			},

			selectGradeByOperatorNums(peratorNum) {

				let that = this;
				this.curId = peratorNum;
				let OperatorNums = {
					operatorNum: this.curId,
				}
				this.$axios
					.post('/api/grade/getNewGradeByOperatorNum', OperatorNums)
					.then(function(res) {

						if(res.data.code == 200) {

							that.operatorname = res.data.data.operatorName;
							that.total_points = res.data.data.totalPoints;
							that.years = res.data.data.year;
							that.quarters = res.data.data.quarter;
							that.greadeDetail(res.data.data.gradeId);

						} else {
							that.$message.error(res.data.msg);
						}

					}).catch(function(error) { // 请求失败处理
						console.log("服务器错误" + error);
					});
			},
			greadeDetail(index) {
				let that = this;
				this.gradeId = index;

				let greade = {
					gradeId: this.gradeId,
				}
				this.$axios
					.post('/api/greadeDetail/selectGradeDetailByGradeId', greade)
					.then(function(res) {
						//  console.log(res.data.data)
						that.itemlist = res.data.data;
					}).catch(function(error) { // 请求失败处理
						console.log("服务器错误" + error);
					});

			},
			init_gaode(code) {
				var that = this;
				window.onLoad = function() {
					var cluster, markers = [];
					
					//初始化地图
					map = new AMap.Map("container_gaode", {
						resizeEnable: true,
						center: [105, 34],
						zoom: 4,
						mapStyle: 'amap://styles/blue'
					});
					//标记点
					//实例化信息窗体
					var title = '',
					    content = [];
					var infoWindow;
					for(var i = 0; i < that.points.length; i += 1) {
						var marker = new AMap.Marker({
							position: that.points[i]['lnglat'],
							content: '<div style="background-color: hsla(180, 100%, 50%, 0.7); height: 24px; width: 24px; border: 1px solid hsl(180, 100%, 40%); border-radius: 12px; box-shadow: hsl(180, 100%, 50%) 0px 0px 1px;"></div>',
							offset: new AMap.Pixel(-15, -15),
							extData:{id:that.points[i].id}
						})
					 	//鼠标点击marker弹出自定义的信息窗体
					    AMap.event.addListener(marker, 'click', function (e) {
					    	that.$axios
							.get('api/vehicleGps/selectVehicle/' + e.target.w.extData.id)
							.then(function(res) {
								if(res.data.code == 200) {
									title = '车牌号:'+res.data.data[0].vehicleLicenseTag;
									content.push("车头码:"+res.data.data[0].vehicleHeadNum);
									content.push("车锁码:"+res.data.data[0].vehicleLockNum);
									infoWindow = new AMap.InfoWindow({
									    isCustom: true,  //使用自定义窗体
									    content: createInfoWindow(title, content.join("<br/>")),
									    offset: new AMap.Pixel(16, -45)
									});
									infoWindow.open(map, marker.getPosition());
									title='';content=[];
								} else {
									that.$message.error(res.data.msg);
								}
								console.log(marker.getPosition())
								infoWindow.open(map, e.target.getPosition());
							}).catch(function(error) { // 请求失败处理
								console.log("服务器错误" + error);
							});
					        
					    });
						markers.push(marker)
					}
//					function markerClick(e) {
//				        infoWindow.setContent(e.target.content);
//				        infoWindow.open(map, e.target.getPosition());
//				    }
					//构建自定义信息窗体
					function createInfoWindow(title, content) {
					    var info = document.createElement("div");
					    info.className = "custom-info input-card content-window-card";
					
					    //可以通过下面的方式修改自定义窗体的宽高
					    //info.style.width = "400px";
					    // 定义顶部标题
					    var top = document.createElement("div");
					    var titleD = document.createElement("div");
					    var closeX = document.createElement("img");
					    top.className = "info-top";
					    titleD.innerHTML = title;
					    closeX.src = "https://webapi.amap.com/images/close2.gif";
					    closeX.onclick = closeInfoWindow;
					
					    top.appendChild(titleD);
					    top.appendChild(closeX);
					    info.appendChild(top);
					
					    // 定义中部内容
					    var middle = document.createElement("div");
					    middle.className = "info-middle";
					    middle.style.backgroundColor = 'white';
					    middle.innerHTML = content;
					    info.appendChild(middle);
					    return info;
					}
					//关闭信息窗体
					function closeInfoWindow() {
					    map.clearInfoWindow();
					}
					
					
										
					//绘制运营区域
					var path = that.polygonPath;
					

					var meituan_path = [[112.551268,37.90542],[112.557984,37.905217],[112.558735,37.913614],[112.557941,37.913901],[112.5580687,37.91576182],[112.5632766,37.91566582],[112.5722941,37.91559218],[112.575695,37.91551918],[112.5778867,37.91611771],[112.577923,37.9121381],[112.5778462,37.9120685],[112.5770171,37.91176407],[112.5766558,37.91209221],[112.5752229,37.91181071],[112.5743655,37.91014906],[112.5740019,37.90928104],[112.5736255,37.90840357],[112.574697,37.908184],[112.575952,37.908193],[112.576043,37.90843],[112.576762,37.908459],[112.577186,37.908379],[112.577679,37.908163],[112.578076,37.907757],[112.579203,37.907697],[112.5803,37.90779],[112.5803055,37.90779439],[112.5806729,37.90759876],[112.5852387,37.90717671],[112.5852196,37.90499107],[112.5908171,37.90503629],[112.5925937,37.90517196],[112.5919442,37.90639291],[112.5926212,37.90750398],[112.598364,37.907487],[112.5986,37.907182],[112.598192,37.90615],[112.597634,37.906014],[112.597463,37.905337],[112.600188,37.905709],[112.601819,37.905456],[112.602655,37.905049],[112.6031827,37.90263675],[112.6031687,37.90259721],[112.6031913,37.90259721],[112.603192,37.902594],[112.6034783,37.90259715],[112.603633,37.89994553],[112.6037038,37.89687155],[112.603549,37.89650518],[112.6036153,37.89329497],[112.6035711,37.88952979],[112.6035199,37.88254385],[112.6035156,37.88196],[112.603406,37.881495],[112.603477,37.880678],[112.603642,37.880208],[112.604458,37.877176],[112.604351,37.876498],[112.604522,37.872772],[112.61229,37.873246],[112.612245,37.865044],[112.6120751,37.85542254],[112.6126112,37.85337819],[112.6087382,37.85178931],[112.6087075,37.85000244],[112.6115201,37.84945201],[112.6106703,37.84767593],[112.6102738,37.84537916],[112.6098311,37.83959762],[112.6124819,37.83963426],[112.6120051,37.83452731],[112.605068,37.83467973],[112.605089,37.832741],[112.605722,37.831038],[112.606355,37.830301],[112.609681,37.826936],[112.610164,37.826081],[112.610454,37.82492],[112.610561,37.823826],[112.610379,37.823072],[112.610314,37.822148],[112.610271,37.820453],[112.610196,37.817877],[112.610186,37.815203],[112.619879,37.815215],[112.622196,37.812223],[112.625909,37.808969],[112.629449,37.806137],[112.632088,37.8039],[112.633893,37.801967],[112.633891,37.801807],[112.6405658,37.79451415],[112.6327503,37.79503936],[112.6319899,37.7893199],[112.6315125,37.78458139],[112.633675,37.785684],[112.639511,37.784005],[112.638267,37.7808],[112.63228,37.775457],[112.643513,37.769419],[112.638191,37.767765],[112.646603,37.763016],[112.646238,37.759725],[112.642912,37.759487],[112.642054,37.755399],[112.638406,37.754992],[112.633632,37.754423],[112.631336,37.755645],[112.630949,37.755289],[112.62831,37.756697],[112.628353,37.75746],[112.62831,37.759462],[112.629168,37.759564],[112.629147,37.76467],[112.626229,37.764737],[112.626229,37.767112],[112.617302,37.76701],[112.617023,37.75271],[112.61256,37.752744],[112.61271,37.743853],[112.612796,37.736523],[112.612882,37.731177],[112.6128807,37.72814423],[112.6184569,37.72792755],[112.623909,37.72788716],[112.6239396,37.72422737],[112.6240207,37.71988625],[112.6238915,37.71529529],[112.6157614,37.71521271],[112.6167678,37.71321097],[112.6171209,37.71239391],[112.6171614,37.71153562],[112.6170854,37.70659932],[112.6095319,37.70660053],[112.597281,37.706606],[112.5961358,37.70660727],[112.5961228,37.7066073],[112.5846422,37.70663889],[112.5744916,37.7064721],[112.5744191,37.7179961],[112.5691456,37.71760605],[112.5684901,37.71719063],[112.5675196,37.71726633],[112.5674943,37.71726555],[112.5676189,37.71750807],[112.5665761,37.71746423],[112.555723,37.717008],[112.559059,37.730373],[112.5552336,37.73051895],[112.551301,37.73035388],[112.5508367,37.73071365],[112.5506707,37.73093511],[112.550875,37.73122165],[112.551501,37.73158256],[112.552127,37.732155],[112.552341,37.734009],[112.553125,37.736228],[112.554251,37.739435],[112.555453,37.742532],[112.555206,37.746621],[112.554455,37.749684],[112.55394,37.751652],[112.554273,37.753009],[112.555431,37.754578],[112.556483,37.755435],[112.55497,37.754672],[112.552191,37.753518],[112.550957,37.752933],[112.548737,37.752042],[112.542492,37.749717],[112.53641,37.746893],[112.531131,37.744195],[112.5290619,37.74332179],[112.520917,37.74474158],[112.5157151,37.74647961],[112.4977619,37.75099863],[112.488218,37.75332211],[112.4811873,37.75530279],[112.4810233,37.75534899],[112.4809453,37.75537097],[112.4805612,37.75502065],[112.479877,37.75438735],[112.4787406,37.75316987],[112.4785369,37.7529783],[112.4770605,37.75159223],[112.4759783,37.75058386],[112.4756782,37.7501911],[112.4753804,37.74964839],[112.4744245,37.74646692],[112.4739576,37.74649819],[112.4749527,37.74976332],[112.4755341,37.7507269],[112.4771132,37.75225804],[112.480464,37.75550656],[112.4799707,37.75564552],[112.481756,37.760992],[112.485682,37.774706],[112.488386,37.782032],[112.489244,37.784475],[112.492463,37.788239],[112.4950321,37.79036609],[112.4953982,37.79164304],[112.495725,37.793089],[112.4958,37.794208],[112.492527,37.794708],[112.488579,37.79492],[112.482238,37.795217],[112.482113,37.79523],[112.482596,37.796004],[112.483283,37.79836],[112.481759,37.79853],[112.481073,37.799242],[112.479721,37.799971],[112.479506,37.800581],[112.477446,37.801684],[112.479592,37.806973],[112.481953,37.80838],[112.484313,37.811669],[112.48457,37.812771],[112.483862,37.813839],[112.482468,37.814127],[112.481974,37.815009],[112.482382,37.817077],[112.48103,37.817433],[112.480901,37.818229],[112.481781,37.819094],[112.481845,37.81928],[112.480923,37.819992],[112.480622,37.820484],[112.481459,37.821619],[112.481802,37.821704],[112.482403,37.821331],[112.4827208,37.82477745],[112.4855013,37.82960346],[112.4858192,37.83416632],[112.4846246,37.83682609],[112.4818217,37.83973184],[112.4776802,37.84259969],[112.4744554,37.84523419],[112.4733674,37.84646752],[112.470473,37.850901],[112.470215,37.853426],[112.4682036,37.85316826],[112.4673782,37.85295637],[112.4663947,37.85232858],[112.4651408,37.85200915],[112.4611861,37.85208541],[112.4596781,37.85121833],[112.4581509,37.85044527],[112.4566803,37.85255808],[112.4559965,37.85372641],[112.4549409,37.85480664],[112.452103,37.85680777],[112.4490047,37.85875012],[112.4497149,37.85961594],[112.4517204,37.86065102],[112.4535961,37.86102244],[112.4584155,37.86128312],[112.4599765,37.86010015],[112.4621932,37.85963685],[112.4649002,37.85940103],[112.4675672,37.85982238],[112.4698639,37.86155401],[112.47139,37.867544],[112.472806,37.871305],[112.473364,37.87493],[112.472549,37.878453],[112.472978,37.885735],[112.473622,37.888072],[112.47364,37.888171],[112.473651,37.888169],[112.4741941,37.88900067],[112.478558,37.88726729],[112.48074,37.8867162],[112.4830631,37.88668493],[112.4861163,37.88703045],[112.4888669,37.8871639],[112.4888888,37.89060188],[112.4887915,37.89447014],[112.4893813,37.89789679],[112.4903133,37.899041],[112.4974232,37.8994215],[112.4963372,37.91775205],[112.4961542,37.92084044],[112.4958265,37.92520213],[112.5006744,37.9253425],[112.5002478,37.92921961],[112.5059145,37.92947095],[112.5102816,37.92970123],[112.5113156,37.92554595],[112.512282,37.921774],[112.51646,37.922404],[112.519116,37.923209],[112.521824,37.924057],[112.520625,37.9274],[112.519946,37.929097],[112.519386,37.930648],[112.522064,37.931419],[112.521381,37.932705],[112.524366,37.933508],[112.524217,37.93372],[112.525584,37.934057],[112.5232225,37.93591603],[112.5234287,37.93811253],[112.5276702,37.93811125],[112.5319,37.934047],[112.537889,37.920002],[112.538477,37.917102],[112.539117,37.915933],[112.539746,37.914953],[112.540594,37.913789],[112.541121,37.91271],[112.542248,37.910519],[112.544012,37.908024],[112.545411,37.905658],[112.54632,37.903607],[112.54705,37.900124],[112.549077,37.900056],[112.550762,37.900573],[112.550955,37.901978],[112.551268,37.90542]
]
					var meituan_path_two=[[112.5411075,37.60486959],[112.5412271,37.60566999],[112.5337487,37.60655612],[112.5339525,37.61226701],[112.5319303,37.62114982],[112.5438833,37.61992445],[112.541754,37.60493057],[112.5411075,37.60486959]];
					var meituan_path_three = [[112.6608497,37.75357798],[112.6619957,37.75411069],[112.6648945,37.75181973],[112.6728308,37.74360036],[112.6676973,37.74330906],[112.6678252,37.74019956],[112.6666871,37.74018098],[112.6666802,37.73959922],[112.6568467,37.73945431],[112.6568398,37.74221282],[112.6574637,37.74235394],[112.6571039,37.7534922],[112.6593022,37.75350911],[112.6608497,37.75357798]]
					var meituan_path_fore =  [[112.5615747,37.70750189],[112.5626059,37.70893739],[112.5639477,37.70836302],[112.5629363,37.70688623],[112.5622253,37.70721518],[112.5622081,37.70722212],[112.5615747,37.70750189]];
					var meituan_path_five = [[112.5768056,37.69903939],[112.5766751,37.69860598],[112.5764607,37.69865589],[112.5765848,37.69908635],[112.5768056,37.69903939]]
					var meituan_path_six = [[112.441293,38.019265],[112.441722,38.019012],[112.443771,38.019079],[112.446904,38.019172],[112.447998,38.019147],[112.454339,38.018445],[112.456002,38.018395],[112.456088,38.017],[112.456056,38.015259],[112.456163,38.014414],[112.458856,38.014354],[112.458867,38.012993],[112.455948,38.013627],[112.455519,38.013712],[112.454114,38.013687],[112.452483,38.013568],[112.451549,38.013501],[112.449532,38.013289],[112.449565,38.011573],[112.44935,38.011463],[112.447633,38.011379],[112.447655,38.010939],[112.445445,38.010796],[112.443975,38.010652],[112.444039,38.00979],[112.442881,38.009418],[112.442312,38.009359],[112.441679,38.009528],[112.440381,38.010508],[112.439855,38.010829],[112.439533,38.010922],[112.439061,38.010914],[112.438997,38.011666],[112.440413,38.011793],[112.440252,38.013763],[112.440349,38.013906],[112.440982,38.013974],[112.44126,38.014904],[112.441443,38.01509],[112.441808,38.016155],[112.441293,38.018724],[112.441293,38.019265]];
					var meituan_path_seven = [[112.5491741,37.70529325],[112.5517955,37.70430265],[112.5514899,37.70380498],[112.5489389,37.70481652],[112.5488895,37.70483372],[112.5491741,37.70529325]];
					var meituan_path_eight = [[112.4559693,38.01932043],[112.4556689,38.02393519],[112.4558835,38.02444229],[112.4556474,38.02729888],[112.46069,38.02750171],[112.4607544,38.01928662],[112.4559693,38.01932043]];
					var meituan_path_nine = [[112.5454503,37.69928151],[112.5457568,37.69973217],[112.5483833,37.69874662],[112.5481045,37.69829268],[112.5454503,37.69928151]];
					var meituan_path_ten = [[112.5829904,37.69642803],[112.5835961,37.69631154],[112.5826555,37.69431709],[112.5819446,37.69277367],[112.5857663,37.69096071],[112.5887783,37.6901428],[112.5910286,37.68960278],[112.5896986,37.68745674],[112.5888975,37.68755534],[112.5897607,37.68900188],[112.5853582,37.69007231],[112.5809736,37.69209064],[112.5829904,37.69642803]];
					
					var haluo_path = path;//传过来的点位比较多 需要整理一下
					
					var qingju_path = [[112.51281748539714,37.92210704144227],[112.5347207721959,37.928235659066345],[112.53949183448935,37.91613422799876],[112.54411655773038,37.90784243842972],[112.54721715125459,37.900392220909936],[112.55265589500607,37.900420435730126],[112.55388005420127,37.904520978642346],[112.55593245070759,37.90506577836095],[112.56018471437699,37.91656924820507],[112.56389809295706,37.91675070511972],[112.56473264678016,37.91342423986309],[112.57433986655701,37.90533904400117],[112.58138801385894,37.90315771073662],[112.58259479455432,37.90080995420564],[112.6037268572478,37.90009574717611],[112.60357876061232,37.881994361681286],[112.60433241728867,37.87636668769355],[112.60493627918413,37.86750049160012],[112.60509155037244,37.86000766765187],[112.60529383690346,37.85532550859596],[112.60525953585011,37.85074465975897],[112.6052667255143,37.83428357886747],[112.60606032537214,37.83167590181241],[112.61103952006943,37.825707970645965],[112.61108470750298,37.816425820399424],[112.61103779616315,37.807180535567504],[112.61111458112748,37.80194229989894],[112.62667516355077,37.80178511609714],[112.62669965177315,37.8008470146499],[112.62214353949162,37.80093075216564],[112.61129413732124,37.80101958591735],[112.61137600783081,37.79920137753966],[112.6023650784739,37.79375158265661],[112.60819255083754,37.78820454726259],[112.61146352902324,37.78558721506261],[112.61682362869442,37.78953802007497],[112.62265518561208,37.785246262307645],[112.61701117561836,37.78123222808786],[112.620835176573,37.77779658193375],[112.62591856786366,37.77525145261641],[112.63219823532563,37.77192597382498],[112.629905,37.767051],[112.627244,37.76717],[112.619583,37.767025],[112.61227643404845,37.76639079700348],[112.61263322500167,37.758266223942684],[112.61756836734298,37.758323484592495],[112.6173603634254,37.75301896684134],[112.61257226240252,37.752967282308596],[112.6124064158962,37.74688850610638],[112.61277044457245,37.740606989990745],[112.6130321616854,37.72831003019128],[112.61558237062297,37.71538827838108],[112.5957369615312,37.71508800468441],[112.59057024047081,37.71573516170363],[112.58340795150616,37.71749047729337],[112.58006259506908,37.71787538074803],[112.57632028703188,37.71779894633106],[112.56787515935548,37.71739252752834],[112.55688920161651,37.71687028623021],[112.54683803884245,37.71948332195402],[112.55171278209605,37.72813264432591],[112.55217850573422,37.72948280305067],[112.55231628104843,37.731060126325076],[112.55149134087242,37.73645513988975],[112.54957466549138,37.74598834524749],[112.54734203758255,37.7559929101762],[112.53822661840559,37.77412365559363],[112.54217228165237,37.752716679892764],[112.51909749510651,37.75289243297362],[112.52058783589291,37.76441109202767],[112.51963414716568,37.77429167296765],[112.52397479010801,37.77926346217444],[112.51930547986728,37.7824563217167],[112.50921924966553,37.786206793992626],[112.49465188509532,37.78815621949023],[112.49584972829439,37.790358478962766],[112.49541738147946,37.79729380294288],[112.49641397146081,37.803776376196474],[112.49776491977218,37.810881577270536],[112.49740021335322,37.81638922076154],[112.49841439582087,37.82202921907357],[112.50060336089496,37.84095329501913],[112.49867914742549,37.84264393802499],[112.49048410679029,37.844833393685334],[112.48957521641114,37.847443558230964],[112.47212499535658,37.85053834517092],[112.47282329119707,37.85309352693],[112.47290886239716,37.855581231015485],[112.47264291746183,37.85669150461157],[112.47075568074479,37.859187381905485],[112.47803775168245,37.861268528286224],[112.48081663967821,37.86169387933056],[112.48650537653907,37.862199575161206],[112.4894884709413,37.862055391545255],[112.48952591248258,37.86814022836694],[112.48898708631589,37.88706235301612],[112.48876132586884,37.899130725226875],[112.49684076097083,37.89922651102677],[112.49567092214102,37.92088690721803]]
					if(code=='HL'){
						var polygon = new AMap.Polygon({
					        path: haluo_path,
					        strokeColor: "#FF33FF", 
					        strokeWeight: 3,
					        strokeOpacity: 0.2,
					        fillOpacity: 0.4,
					        fillColor: '#1791fc',
					        zIndex: 60,
					    })
						map.add(polygon)
						// 缩放地图到合适的视野级别
						map.setFitView([ polygon ])
					}else if (code=='DD'){
						var polygon = new AMap.Polygon({
						    path: qingju_path,
						    strokeColor: "#FF33FF", 
						    strokeWeight: 3,
						    strokeOpacity: 0.2,
						    fillOpacity: 0.4,
						    fillColor: '#260079',
						    zIndex: 60,
						})
						map.add(polygon)
						// 缩放地图到合适的视野级别
						map.setFitView([ polygon ])
					}else{
						function addPolygon(path){
							var polygon = new AMap.Polygon({
							    path: path,
							    strokeColor: "#FF33FF", 
							    strokeWeight: 3,
							    strokeOpacity: 0.2,
							    fillOpacity: 0.4,
							    fillColor: '#260079',
							    zIndex: 60,
							})
							map.add(polygon);
							map.setFitView([ polygon ])
						}
						
						addPolygon(meituan_path_two);
						addPolygon(meituan_path_three);
						addPolygon(meituan_path_fore);
						addPolygon(meituan_path_five);
						addPolygon(meituan_path_six);
						addPolygon(meituan_path_seven);
						addPolygon(meituan_path_eight);
						addPolygon(meituan_path_nine);
						addPolygon(meituan_path_ten);
						addPolygon(meituan_path);
						
					}
					
					//点聚合自定义样式
					var count = markers.length;
					var _renderClusterMarker = function(context) {
						var factor = Math.pow(context.count / count, 1 / 18);
						var div = document.createElement('div');
						var Hue = 180 - factor * 180;
						var bgColor = 'hsla(' + Hue + ',100%,50%,0.7)';
						var fontColor = 'hsla(' + Hue + ',100%,20%,1)';
						var borderColor = 'hsla(' + Hue + ',100%,40%,1)';
						var shadowColor = 'hsla(' + Hue + ',100%,50%,1)';
						div.style.backgroundColor = bgColor;
						var size = Math.round(30 + Math.pow(context.count / count, 1 / 5) * 20);
						div.style.width = div.style.height = size + 'px';
						div.style.border = 'solid 1px ' + borderColor;
						div.style.borderRadius = size / 2 + 'px';
						div.style.boxShadow = '0 0 1px ' + shadowColor;
						div.innerHTML = context.count;
						div.style.lineHeight = size + 'px';
						div.style.color = fontColor;
						div.style.fontSize = '14px';
						div.style.textAlign = 'center';
						context.marker.setOffset(new AMap.Pixel(-size / 2, -size / 2));
						context.marker.setContent(div)
					};
					addCluster(3);
					function addCluster(tag) {
						if(cluster) {
							cluster.setMap(null);
						}
						if(tag == 2) { //完全自定义
							cluster = new AMap.MarkerClusterer(map, markers, {
								gridSize: 80,
								renderClusterMarker: _renderClusterMarker
							});
						} else if(tag == 1) { //自定义图标
							var sts = [{
								url: "https://a.amap.com/jsapi_demos/static/images/blue.png",
								size: new AMap.Size(32, 32),
								offset: new AMap.Pixel(-16, -16)
							}, {
								url: "https://a.amap.com/jsapi_demos/static/images/green.png",
								size: new AMap.Size(32, 32),
								offset: new AMap.Pixel(-16, -16)
							}, {
								url: "https://a.amap.com/jsapi_demos/static/images/orange.png",
								size: new AMap.Size(36, 36),
								offset: new AMap.Pixel(-18, -18)
							}, {
								url: "https://a.amap.com/jsapi_demos/static/images/red.png",
								size: new AMap.Size(48, 48),
								offset: new AMap.Pixel(-24, -24)
							}, {
								url: "https://a.amap.com/jsapi_demos/static/images/darkRed.png",
								size: new AMap.Size(48, 48),
								offset: new AMap.Pixel(-24, -24)
							}];
							cluster = new AMap.MarkerClusterer(map, markers, {
								styles: sts,
								gridSize: 80
							});
						} else { //默认样式
							cluster = new AMap.MarkerClusterer(map, markers, {
								gridSize: 80
							});
						}
					}
				};
				// key是申请的值
				var url =
					"https://webapi.amap.com/maps?v=1.4.15&key=f3b0d3425c983ea30a3ba93111004ffb&callback=onLoad&plugin=AMap.MarkerClusterer";
				//创建一个 script dom元素
				// doc需要补全document
				var jsapi = document.createElement("script");
				//设定script标签属性
				jsapi.charset = "utf-8";
				jsapi.src = url;

				// key是申请的值
				var url_two =
					"//a.amap.com/jsapi_demos/static/china.js";
				//创建一个 script dom元素
				// doc需要补全document
				var jsapi_two = document.createElement("script");
				//设定script标签属性
				jsapi_two.charset = "utf-8";
				jsapi_two.src = url_two;
				//将API文件引入页面中,加载完毕以后会调用函数

				document.head.appendChild(jsapi_two);
				document.head.appendChild(jsapi);
			}

		},
		watch: {

		},
		computed: {
			optionHover() {
				return {
					step: 0.5, // 数值越大速度滚动越快
					limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
					hoverStop: true, // 是否开启鼠标悬停stop
					direction: 1, // 0向下 1向上 2向左 3向右
					openWatch: true, // 开启数据实时监控刷新dom
					singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
					singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
					waitTime: 1500, // 单步运动停止的时间(默认值1000ms)

				};
			},

		},

	})
</script>
<style>
	.BMap_center {
		height: 120px !important;
	}
	
	#he-plugin-simple>div {
		padding: 0 !important;
	}
	
	.pie-data p {
		width: 100%;
		height: 0.45rem;
		line-height: 0.45rem;
		font-size: 0.2rem;
		color: #cdddf7;
		display: flex;
		flex-flow: row nowrap;
		justify-content: space-around;
		cursor: default;
		margin: 0!important;
	}
	
	.pie-data p>span {
		width: 0;
		flex-grow: 1;
		margin: 0 5px;
		text-align: left;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	
	.pie-data p>.pie-number {
		flex-grow: 2;
	}
	
	.legend {
		display: inline-block;
		width: 0.2rem;
		height: 0.16rem;
		line-height: 0.2rem;
		border-radius: 2px;
		background: white;
	}
	
	.fullscreen {
		width: 0.9rem;
		height: 0.9rem;
		background: url(../../assets/images/f1.png) top left no-repeat;
		background-size: 100%;
		position: absolute;
		top: 0%;
		right: 0%;
		z-index: 999999;
		cursor: pointer;
	}
	
	.exit-fullscreen {
		width: 0.9rem;
		height: 0.9rem;
		background: url(../../assets/images/f.png) top left no-repeat;
		background-size: 100%;
		position: absolute;
		top: 0%;
		right: 0%;
		z-index: 999999;
		cursor: pointer;
	}
	.fullscreens {
		width: 0.9rem;
		height: 0.9rem;
		background: url(../../assets/images/jin/big.png) top left no-repeat;
		background-size: 100%;
		position: absolute;
		top: 0%;
		right: 0%;
		z-index: 999999;
		cursor: pointer;
	}
	
	.exit-fullscreens {
		width: 0.9rem;
		height: 0.9rem;
		background: url(../../assets/images/jin/small.png) top left no-repeat;
		background-size: 100%;
		position: absolute;
		top: 0%;
		right: 0%;
		z-index: 999999;
		cursor: pointer;
	}
	.map {
		width: 100%;
		height: 100%;
	}
	
	.BMap_cpyCtrl {
		display: none!important;
	}
	
	.anchorBL {
		display: none!important;
	}
	
	#he-plugin-simple>div {
		padding: 0 !important;
	}
	
	.content-window-card{
		line-height: 30px ;
	    font-size: 14px ;
	    color: #000;
	    background: #fff;
	}
	.amap-info>div{
		/*top: 100px;*/
	}
	div.custom-info div {
        padding: 0 10px;
    }
	div.info-top {
        position: relative;
    }
	 div.info-top img {
        position: absolute;
        top: -2px;
        right: -2px;
        transition-duration: 0.25s;
    }	
    .amap-info{
    	top: 248px !important;	
    }
    
    .weather-box div{
    	font-size: 0.3rem;
    	color: #cdddf7 !important;
    }
</style>
<style scoped>
	@import '../../assets/css/zlstyle.css';
	.el-main {
		padding: 0!important;
	}
	
	.mapDian_box {
		background: red;
	}
	
	.mapDian_box_li {
		height: 40px;
		line-height: 40px;
	}
	
	.mapDian_box_li:after {
		/*START 真正起到清除浮动的代码*/
		content: '';
		display: block;
		clear: both;
		/*END 真正起到清除浮动的代码*/
		height: 0;
	}
	
	.mapDian_box_li_l,
	.mapDian_box_li_r {
		line-height: 30px;
		font-size: 14px;
		color: #000;
		float: left;
		/*overflow: hidden;
	text-overflow:ellipsis;
	white-space: nowrap;*/
	}
	
	.jin_zz {
		width: 100vw;
		height: 120vh;
		position: fixed;
		top: 0;
		left: 0;
		background: transparent;
		z-index: 9999999999999;
	}
	
	#container_gaode {
		width: 100%;
		height: 100%;
	}
	
	
</style>


// WEBPACK FOOTER //
// src/view/admin/Index.vue